var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import Autocomplete, { createFilterOptions, } from '@material-ui/lab/Autocomplete';
import { CircularProgress, Paper } from '@material-ui/core';
import TextField from '../MuiFields';
import Button from '../Button';
import useStyles from './style';
var AppendableSelect = function (props) {
    var textFieldProps = props.textFieldProps, addLabel = props.addLabel, disabled = props.disabled, onAddClick = props.onAddClick, onItemChange = props.onItemChange, autocompleteProps = __rest(props, ["textFieldProps", "addLabel", "disabled", "onAddClick", "onItemChange"]);
    var classes = useStyles();
    var filterOptions = createFilterOptions({
        matchFrom: 'any',
        ignoreCase: true,
        trim: true,
        stringify: function (option) {
            return autocompleteProps.getOptionLabel
                ? autocompleteProps.getOptionLabel(option)
                : option.toString();
        },
    });
    var renderInput = useCallback(function (params) {
        return (_jsx(TextField, __assign({}, params, { inputProps: __assign(__assign({}, params.inputProps), { autoComplete: 'off' }), InputProps: __assign(__assign({}, params.InputProps), { autoComplete: 'off', endAdornment: (_jsxs(_Fragment, { children: [autocompleteProps.loading ? _jsx(CircularProgress, { color: "inherit", size: 20 }, void 0) : null, params.InputProps.endAdornment] }, void 0)) }), variant: "outlined", fullWidth: true }, textFieldProps), void 0));
    }, [autocompleteProps.loading, textFieldProps]);
    var handleChange = useCallback(function (event, option, reason) {
        if (typeof onItemChange === 'function') {
            onItemChange(option, reason);
        }
    }, [onItemChange]);
    var OptionsPaper = function (_a) {
        var children = _a.children;
        return (_jsxs(Paper, { children: [_jsx("ul", __assign({ className: classes.linkedList }, { children: _jsxs("li", __assign({ className: classes.linked }, { children: ["+", ' ', _jsx(Button, __assign({ variant: "link", onMouseDown: function (e) { return e.preventDefault(); }, onClick: onAddClick }, { children: addLabel }), void 0)] }), void 0) }), void 0), children] }, void 0));
    };
    return (_jsx(Autocomplete, __assign({ classes: { popper: classes.popper }, disabled: disabled, size: "small", filterOptions: filterOptions, "data-testid": "appendable-select-" + textFieldProps.name, renderInput: renderInput }, autocompleteProps, { PaperComponent: OptionsPaper, onChange: handleChange }), void 0));
};
export default AppendableSelect;
